import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BaseElement from '../BaseElement/BaseElement';
import defer from 'lodash/defer';
import $ from 'jquery';
/* let jQuery;
defer(() => {
  jQuery = require('jquery');
});*/
import shallowEqual from 'fbjs/lib/shallowEqual';

export default class IconElement extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  render() {
    const {data, compProps, layout} = this.props;
    const { rawSVG } = data;
    const $svg = $(rawSVG);
    $svg.children().attr('fill', compProps.fill);
    $svg.attr('style', 'height: 100%; width: 100%');
    $svg.removeAttr('xmlns');
    return (
      <BaseElement {...this.props}>
        <div style={{...data.compProps, height: '100%', width: '100%', display: 'flex'}}
             dangerouslySetInnerHTML={{__html: $svg[0].outerHTML}}></div>
      </BaseElement>
    );
  }
}

IconElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }),
  data: PropTypes.shape({
    rawSVG: PropTypes.string.isRequired,
    compProps: PropTypes.object,
    href: PropTypes.string
  })
};